import { render, staticRenderFns } from "./upLoadImage.vue?vue&type=template&id=44530876&"
import script from "./upLoadImage.vue?vue&type=script&lang=js&"
export * from "./upLoadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports